import { anchorStorage } from 'utils';

export const transitionAnchorScroll = (
  $anchorScroll,
  $location,
  $timeout,
  $transitions
) => {
  'ngInject';

  $transitions.onSuccess('*', $transition$ => {
    const { name, hash } = anchorStorage.get();
    const targetName = $transition$.targetState().name();

    if (name === targetName && hash) {
      anchorStorage.remove();
      $location.hash(hash);
    }

    $timeout(() => $anchorScroll());
  });
};



// WEBPACK FOOTER //
// ./src/utils/transitionAnchorScroll.js